// extracted by mini-css-extract-plugin
export var labelWrapper = "_d0-0";